"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartingStatusBarPopover = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const AdaptableContext_1 = require("../AdaptableContext");
const ModuleConstants = tslib_1.__importStar(require("../../Utilities/Constants/ModuleConstants"));
const useChartingElements_1 = require("./useChartingElements");
const rebass_1 = require("rebass");
const ChartingStatusBarPopover = (props) => {
    const adaptable = (0, AdaptableContext_1.useAdaptable)();
    const accessLevel = adaptable.api.internalApi
        .getEntitlementService()
        .getEntitlementAccessLevelForModule(ModuleConstants.ChartingModuleId);
    const { chartSelector, containerSelector, chartButton, deleteButton, editButton } = (0, useChartingElements_1.useChartingElements)({
        elementType: 'Statusbar',
        accessLevel: accessLevel,
        size: 'small',
    });
    return (React.createElement(rebass_1.Flex, { width: "100%", alignItems: "center" },
        React.createElement(rebass_1.Box, null, chartSelector),
        containerSelector && React.createElement(rebass_1.Box, { ml: 1 }, containerSelector),
        React.createElement(rebass_1.Box, { ml: 1 },
            chartButton,
            deleteButton,
            editButton)));
};
exports.ChartingStatusBarPopover = ChartingStatusBarPopover;
